module.exports = __webpack_public_path__ + "static/img/29.1639f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/29.png
// module id = iiqk
// module chunks = 0